import { gql } from "@/graphql/typed-gql"

export const DELETE_OLD_LOGS = gql`
  mutation DeleteOldLogs($daysToKeep: Int!) {
    deleteOldLogs(daysToKeep: $daysToKeep) {
      deletedCount
    }
  }
`

export const SAVE_SETTINGS = gql`
  mutation SaveSettings(
    $geminiMode: String
    $chatAiProvider: String
    $generationAiProvider: String
    $evaluationAiProvider: String
    $adjudicationAiProvider: String
    $taggingAiProvider: String
    $reportsAiProvider: String
    $deepseekChatThinking: Boolean
    $aiCreditsMetered: Boolean
    $autoGuardianReports: Boolean
    $impersonationEnabled: Boolean
    $defaultExerciseCount: Int
  ) {
    saveSettings(
      geminiMode: $geminiMode
      chatAiProvider: $chatAiProvider
      generationAiProvider: $generationAiProvider
      evaluationAiProvider: $evaluationAiProvider
      adjudicationAiProvider: $adjudicationAiProvider
      taggingAiProvider: $taggingAiProvider
      reportsAiProvider: $reportsAiProvider
      deepseekChatThinking: $deepseekChatThinking
      aiCreditsMetered: $aiCreditsMetered
      autoGuardianReports: $autoGuardianReports
      impersonationEnabled: $impersonationEnabled
      defaultExerciseCount: $defaultExerciseCount
    ) {
      success
      errors
    }
  }
`

export const LOGIN = gql`
  mutation Login($password: String!, $email: String) {
    login(password: $password, email: $email) {
      success
      error
      # „This address is not confirmed yet" rather than „wrong password". The two
      # need telling apart because only one of them has anything to offer —
      # „atsiųsti nuorodą dar kartą" — and a correction the reader cannot act on
      # reads as a dead end.
      needsConfirmation
    }
  }
`

export const LOGOUT = gql`
  mutation Logout {
    logout {
      success
    }
  }
`

export const SAVE_SVG_SHAPE = gql`
  mutation SaveSvgShape($shapeType: String!, $paramsJson: String, $outputPath: String) {
    saveSvgShape(shapeType: $shapeType, paramsJson: $paramsJson, outputPath: $outputPath) {
      success
      svg
      svgPath
      yamlPath
      error
    }
  }
`

export const GENERATE_EXERCISE_FILES = gql`
  mutation GenerateExerciseFiles(
    $skillKey: String!
    $subject: String!
    $grade: Int!
    $level: Int!
    $count: Int
    $model: String
    $promptOverride: String
    $conceptKey: String
  ) {
    generateExerciseFiles(
      skillKey: $skillKey
      subject: $subject
      grade: $grade
      level: $level
      count: $count
      model: $model
      promptOverride: $promptOverride
      conceptKey: $conceptKey
    ) {
      success
      successCount
      errorCount
      errors
      generatedFiles
      generatedExercises {
        filePath
        problemHtml
        answer
        choices
        hint
      }
    }
  }
`

export const GENERATE_SUGGESTED_EXERCISES = gql`
  mutation GenerateSuggestedExercises(
    $subject: String!
    $grade: Int
    $count: Int
    $model: String
  ) {
    generateSuggestedExercises(
      subject: $subject
      grade: $grade
      count: $count
      model: $model
    ) {
      success
      suggested
      skillKey
      skillName
      grade
      level
      reason
      fallbackGrade
      successCount
      errorCount
      errors
    }
  }
`

export const APPROVE_EXERCISE_FILES = gql`
  mutation ApproveExerciseFiles($filePaths: [String!]!) {
    approveExerciseFiles(filePaths: $filePaths) {
      success
      approvedCount
      errors
    }
  }
`

export const REJECT_EXERCISE_FILES = gql`
  mutation RejectExerciseFiles($filePaths: [String!]!) {
    rejectExerciseFiles(filePaths: $filePaths) {
      success
      rejectedCount
      errors
    }
  }
`

export const SAVE_EXERCISE_FILE = gql`
  mutation SaveExerciseFile($filePath: String!, $jsonContent: String!) {
    saveExerciseFile(filePath: $filePath, jsonContent: $jsonContent) {
      success
      error
    }
  }
`

export const SAVE_SKILL_PROMPT = gql`
  mutation SaveSkillPrompt(
    $skillKey: String!
    $subject: String!
    $grade: Int!
    $content: String!
  ) {
    saveSkillPrompt(
      skillKey: $skillKey
      subject: $subject
      grade: $grade
      content: $content
    ) {
      success
      filePath
      error
    }
  }
`

export const SAVE_PROMPT_LAYER = gql`
  mutation SavePromptLayer(
    $layerKey: String!
    $subject: String
    $grade: Int
    $level: Int
    $content: String!
  ) {
    savePromptLayer(
      layerKey: $layerKey
      subject: $subject
      grade: $grade
      level: $level
      content: $content
    ) {
      success
      filePath
      error
    }
  }
`

export const GENERATE_THEORY = gql`
  mutation GenerateTheory(
    $skillKey: String!
    $subject: String!
    $grade: Int!
    $model: String
    $promptOverride: String
  ) {
    generateTheory(
      skillKey: $skillKey
      subject: $subject
      grade: $grade
      model: $model
      promptOverride: $promptOverride
    ) {
      success
      error
      theoryHtml
      theoryPath
      conceptsTotal
      conceptsCovered
      missingConcepts
    }
  }
`

export const SAVE_THEORY_PROMPT_LAYER = gql`
  mutation SaveTheoryPromptLayer(
    $layerKey: String!
    $subject: String
    $grade: Int
    $content: String!
  ) {
    saveTheoryPromptLayer(
      layerKey: $layerKey
      subject: $subject
      grade: $grade
      content: $content
    ) {
      success
      filePath
      error
    }
  }
`

export const SAVE_THEORY_SKILL_PROMPT = gql`
  mutation SaveTheorySkillPrompt(
    $skillKey: String!
    $subject: String!
    $grade: Int!
    $content: String!
  ) {
    saveTheorySkillPrompt(
      skillKey: $skillKey
      subject: $subject
      grade: $grade
      content: $content
    ) {
      success
      filePath
      error
    }
  }
`

export const SAVE_SHAPE_PACK = gql`
  mutation SaveShapePack($filename: String!, $content: String!) {
    saveShapePack(filename: $filename, content: $content) {
      success
      filePath
      error
    }
  }
`

export const RESOLVE_CONTENT_FLAG = gql`
  mutation ResolveContentFlag($kind: String!, $filePath: String!, $action: String!) {
    resolveContentFlag(kind: $kind, filePath: $filePath, action: $action) {
      success
      message
      errors
    }
  }
`

/**
 * The handoff: the review queue as markdown — what a child said, what the
 * adjudicator suspected, the file path and the question's own JSON — ready to
 * paste to whoever is going to fix it.
 *
 * A mutation and not a query because copying stamps the flags it covered as
 * handed over. **Copying is not dismissing**: the flag stays in the queue, since
 * the row is what says whether the fix ever landed.
 *
 * With `filePath` it is one flag in full; without, the whole queue.
 */
export const COPY_FLAG_REPORT = gql`
  mutation CopyFlagReport($target: String, $filePath: String, $limit: Int) {
    copyFlagReport(target: $target, filePath: $filePath, limit: $limit) {
      report
      copiedCount
      errors
    }
  }
`

/**
 * Topping up AI credits by hand. The balance comes back on the same row the
 * cache already holds, so the number on screen moves without a refetch.
 */
export const GRANT_AI_CREDITS = gql`
  mutation GrantAiCredits($studentId: ID!, $amount: Int!) {
    grantAiCredits(studentId: $studentId, amount: $amount) {
      errors
      student {
        id
        aiCredits
        monthlyAiCredits
      }
    }
  }
`

export const SET_SUBSCRIPTION = gql`
  mutation SetSubscription($studentId: ID!, $subscribedFrom: ISO8601Date, $subscribedUntil: ISO8601Date) {
    setSubscription(
      studentId: $studentId
      subscribedFrom: $subscribedFrom
      subscribedUntil: $subscribedUntil
    ) {
      errors
      student {
        id
        subscribed
        subscribedFrom
        subscribedUntil
      }
    }
  }
`
